// extracted by mini-css-extract-plugin
export default {"image":"rY-z","loaded":"sY-z"};